import {NgModule} from '@angular/core';
import {WebAuthnModule} from '../web-authn/web-authn.module';
import {AuthHttpModule} from './auth-http.module';
import {AuthWithTokenGuard} from './auth-with-token.guard';
import {AuthGuard} from './auth.guard';
import {AuthService} from './auth.service';
import {BackofficeAuthGuard} from './backoffice-auth.guard';
import {ClientAuthGuard} from './client-auth.guard';
import {DexAuthClientService} from './dex-auth-client.service';
import {LoginPageGuard} from './login-page.guard';

@NgModule({
    imports: [
        AuthHttpModule,
        WebAuthnModule
    ],
    providers: [
        {
            provide: AuthService,
            useClass: DexAuthClientService
        },
        AuthGuard,
        AuthWithTokenGuard,
        ClientAuthGuard,
        BackofficeAuthGuard,
        LoginPageGuard
    ]
})
export class AuthModule {}
